import { CircleOff } from "lucide-react";

interface AnalysisUnavailableProps {
  readonly title?: string;
  readonly reason: string;
  readonly activePair?: string;
}

/**
 * A visible, keyboard-reachable explanation for an unavailable analytical view.
 * The reason is intentionally rendered as text instead of a hover-only tooltip.
 */
export function AnalysisUnavailable({
  title = "Analysis unavailable",
  reason,
  activePair,
}: AnalysisUnavailableProps) {
  return (
    <section
      role="status"
      tabIndex={0}
      aria-labelledby="analysis-unavailable-heading"
      className="rounded-xl border border-warning/35 bg-warning/5 p-5 shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
      data-testid="analysis-unavailable"
    >
      <div className="flex items-start gap-3">
        <CircleOff aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-warning" />
        <div>
          <h2 id="analysis-unavailable-heading" className="text-base font-bold text-primary">
            {title}
          </h2>
          <p className="mt-1 text-sm leading-relaxed text-secondary">{reason}</p>
          {activePair ? (
            <p className="mt-3 text-xs font-semibold text-warning">Selected contracts: {activePair}</p>
          ) : null}
        </div>
      </div>
    </section>
  );
}
